import { Card, Row, Col, Input, Switch, Typography, Form, Button, Spin } from 'antd';
import { useTranslation } from "react-i18next";
import { useResourceContext } from "@/layouts/ResourceContext";
import { useResourceNavigate } from "@/hooks/useResourceNavigate";
import { RESOURCE_TYPE_VERSIONS, NAV_TO_VERSION_LIST } from '@/resources-def/versionSettings-comp';
import  { useState, useEffect } from 'react';
import { useCreate, useUpdate, useOne, useList, useInvalidate } from "@refinedev/core";
import { TopBreadcrumb } from "@/layouts/TopBreadcrumb";

const { TextArea } = Input;
const { Text } = Typography;

export const CreateVersionPage = () => {
  const { data, isLoading } = useList({
    resource: "versionSettings"
  });
  const latest = data && data.data && data.data.length > 0 ? data.data[0] : null;
  
  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
        <Spin size="large" />
      </div>
    );
  }
  
  return (
      <Editor  instance={latest}/>
  )
}

export const EditVersionPage = () => {
  const { state } = useResourceContext();
  const selected = state.selectedResources[0];
  const { data, isLoading } = useOne({
    resource: "versionSettings",
    id: selected?.sprint,
    skip: !selected,
  });
  const instance = data || selected;
  return (
    <Editor isCreate={false} instance={instance}/>
  )
}

const Editor = ({isCreate=true, instance}) => {
  const navigate = useResourceNavigate();
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [isOkDisabled, setIsOkDisabled] = useState(true);
  const values = Form.useWatch([], form);
  const invalidate = useInvalidate();
  const { mutate } = useCreate({
    resource: RESOURCE_TYPE_VERSIONS,
    mutationOptions: {
      onSuccess: (data) => {
        console.log(data);
        navigate({ resource: NAV_TO_VERSION_LIST, action: "list" });
      },
    },
  });
  const { mutate: updateMutate } = useUpdate({
    resource: RESOURCE_TYPE_VERSIONS,
    successNotification: (data, values, resource) => {
      invalidate({
        resource,
        invalidates: ["list"],
      });
      navigate({
        resource: NAV_TO_VERSION_LIST,
        //key: instance?.sprint,
        action: "list",
      });
      return {
        message: t(`settings.actionResult.edit.success`, {
          resource: "version",
          id:instance?.sprint,
        }),
        type: "success",
      };
    },
    errorNotification: (data, values, resource) => {
      return {
        message: t(`settings.actionResult.edit.failed`, {
          resource: "version",
          id:instance?.sprint,
        }),
        type: "error",
      };
    },
  });
  useEffect(() => {
      form
      .validateFields({
          validateOnly: true,
      })
      .then(() => {
        setIsOkDisabled(false);
      })
      .catch(() => {
        setIsOkDisabled(true);
      });
  }, [form, values]);

  // Reset form when instance changes to populate with actual data
  useEffect(() => {
    if (instance) {
      form.resetFields();
    }
  }, [instance, form]);

  const initialValues = instance || {sprint:"", aiops_image_version:"", viaops_image_version:"", included_modules:"", optional_modules:"", lts:false, upgrade_from:""};
  const isVersionValid = (value, field) => {
      //return /^[0-9]+\.[0-9]+\.[0-9]+$/.test(value);
      return true;
  };
  const handleCancel = () => {
      navigate({ resource: NAV_TO_VERSION_LIST, action: "list" });
  };
  const doSave = () => {
    form.validateFields().then(values => {
      if(isCreate){
        mutate({ values });
      } else {
        updateMutate({ id: instance.sprint, values });
      }
    }).catch(info => {
        console.log('Validate version field Failed:', info);
    });
  }

  const layout = {
    labelCol: {
      span: 8,
    },
    wrapperCol: {
      span: 16,
    },
  };
  const tailLayout = {
    wrapperCol: {
      offset: 8,
      span: 16,
    },
  };
  return (<div>
    <TopBreadcrumb />
    <Card title={isCreate?"Create new version":"Edit version"} style={{ maxWidth: 600, minHeight: 200, marginTop: 0 }}>
      
      <Form {...layout} form={form} component={false} layout="vertical" style={{maxWidth: 600,}} initialValues={initialValues}>
          <Form.Item
                name="sprint"
                label="Version"
                rules={[
                    {
                        required: isCreate,
                        message: 'Please input the version',
                    },
                    {
                        validator: (_, value) =>
                            isVersionValid(value, 'sprint') ? Promise.resolve() : Promise.reject('Version is invalid.'),
                    },
                ]}
            >
                <Input disabled={!isCreate}/>
            </Form.Item>
            <Form.Item
                name="aiops_image_version"
                label="Image version"
                rules={[
                    {
                        required: isCreate,
                        message: 'Please input the image version',
                    },
                    {
                        validator: (_, value) =>
                            isVersionValid(value, 'sprint') ? Promise.resolve() : Promise.reject('Image version is invalid.'),
                    },
                ]}
            >
                <Input disabled={!isCreate}/>
            </Form.Item>
            <Form.Item
                name="viaops_image_version"
                label="Platform"
                rules={[
                    {
                        required: true,
                        message: 'Please input the platform version',
                    }
                ]}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name="included_modules"
                label="Modules"
                
            >
                <TextArea rows={3} 
               style={{width:"100%",height:"100%", resize:"none"}}/>   
            </Form.Item>
            <Form.Item
                name="optional_modules"
                label="Optional modules"               
            >
                <Input />
            </Form.Item>
            <Form.Item
                name="upgrade_from"
                label="Upgrade from"
            >
                <TextArea rows={3} 
               style={{width:"100%",height:"100%", resize:"none"}}/>   
            </Form.Item>
            <Form.Item
                name="lts"
                label="LTS"
            >
              <Switch
                checkedChildren="ON"
                unCheckedChildren="OFF"
              />
            </Form.Item>
            <Form.Item {...tailLayout}>
            <Button
                type="primary"
                style={{
                    marginTop: 16,
                    marginRight: 8,
                }}
                disabled={isOkDisabled}
                onClick={doSave}
            >
                {isCreate?"Create":"Save"}
            </Button>
            <Button
                type="default"
                style={{
                    marginTop: 16,
                }}
                onClick={handleCancel}
            >
                Cancel
            </Button>
            </Form.Item>
        </Form>
    </Card>
    </div>
  );
}